// extracted by mini-css-extract-plugin
export default {"root":"PriceFilterMobile_root__r7y1n","priceFormWrapper":"PriceFilterMobile_priceFormWrapper__evKF4"};